<template>
  <div>
    <card>
      <Button type="primary" size="small" style="margin: 5px;" @click="add">新增</Button>
      <Table :columns="cateTable.columns" :data="cateTable.data"></Table>
    </card>
    <Modal v-model="showModal" title="编辑科目类别">
      <Form :model="cateModel" ref="cateModel" :rules="cateRules" :label-width="60">
        <FormItem label="名称" prop="name">
          <Input v-model="cateModel.name" type="text" placeholder="请输入名称"/>
        </FormItem>
        <FormItem label="说明" prop="remark">
          <Input v-model="cateModel.remark" type="text" placeholder=""/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" size="small" @click="saveCate('cateModel')">确认</Button>
        <Button type="default" size="small" @click="modelcancle">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    name: 'course_cate',
    data() {
      return {
        cateTable: {
          columns: [
            {
              title: '名称',
              key: 'name',
              align: 'center'
            },
            {
              title: '说明',
              key: 'remark',
              align: 'center'
            },
            {
              title: '操作',
              align: 'center',
              render: (h, params) => {
                let self = this;
                let opArray = [];
                opArray.push(h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.cateModel.id=params.row.id;
                      this.cateModel.name=params.row.name;
                      this.cateModel.remark=params.row.remark
                      this.showModal=true
                    }
                  }
                }, '修改'));
                opArray.push(h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '确认删除?',
                        content: '确认删除该课程类型?',
                        onOk() {
                          this.$api.course.delCate({id:params.row.id}).then(res=>{
                            if(res.state=="ok"){
                              self.$Message.success("删除成功")
                              self.getCateList()
                            }else{
                              self.$Message.error(res.msg)
                            }
                            self.showModal=false
                          })
                        },
                        onClose() {

                        }
                      })
                    }
                  }
                }, '删除'));
                return h('div', opArray);
              }
            }
          ],
          data: []
        },
        showModal: false,
        cateModel: {
          id: '',
          name: '',
          remark: ''
        },
        cateRules: {
          name: [{required: true, message: '请输入类别名称', trigger: 'blur'}]
        }
      }
    },
    methods: {
      getCateList() {
        this.cateTable.data = [];
        this.$api.course.getCateList().then(res => {
          if (res.state == "ok") {
            this.cateTable.data = res.cateList;
          } else {
            this.$Message.error(res.msg);
          }
        })
      },
      add() {
        this.cateModel.id = '';
        this.$refs.cateModel.resetFields()
        this.showModal = true
      },
      saveCate(name) {
        let self = this;
        self.$refs[name].validate((valid) => {
          if (valid) {
            this.$api.course.saveCate(this.packagingFormData()).then(res=>{
              if(res.state=="ok"){
                this.$Message.success("保存成功");
                this.$refs.cateModel.resetFields()
                this.getCateList()
              }else{
                this.$Message.error("保存失败")
              }
              this.showModal=false
            })
          }
          else{
            this.$Message.error("表单验证不通过")
            this.$Message.error("表单验证不通过")
          }
        })
      },
      packagingFormData() {
        let postFormData = {};
        for (var i in this.cateModel) {
          if (this.cateModel.hasOwnProperty(i)) {
            postFormData['cate.' + i] = this.cateModel[i];
          }
        }
        return postFormData;
      },
      modelcancle(){
        this.$refs.cateModel.resetFields()
        this.showModal=false
      }
    },
    mounted() {
      this.getCateList()
    }
  }
</script>
